import {
  Component,
  Input,
  OnInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  DestroyRef,
  inject,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Observable, tap } from 'rxjs';
import { AccountService } from 'app/core';
import { Activity } from 'app/core/models/account.types';
import { RelatedToType } from '@shared/enums';
import {
  PanelsInterfaceComponent,
  PanelsInterfaceComponentBase,
} from 'app/modules/projects/details/dashboard/panels/panels-interface.component';

@Component({
  selector: 'project-panel-activity',
  templateUrl: './activity.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PanelsActivityComponent extends PanelsInterfaceComponentBase implements PanelsInterfaceComponent, OnInit {
  @Input() relatedToType?: RelatedToType;
  @Input() model?: any;

  public activities$: Observable<Activity[]>;
  public loading = true;

  private readonly destroyRef = inject(DestroyRef);

  constructor(
    private readonly accountService: AccountService,
    protected readonly changeDetectorRef: ChangeDetectorRef,
  ) {
    super(changeDetectorRef);
  }

  ngOnInit(): void {
    this.titleFieldDef = {
      name: 'activity.panel_name',
      label: this.panelDef.title,
      type: 'text',
    };

    this.panelColor = this.panelDef?.color;

    let payload: any = {
      per_page: 25,
      related_to_id: this.model.id,
    };

    if (this.relatedToType?.startsWith('co_')) {
      payload.related_to_type = RelatedToType.CustomObjectValue;
    } else {
      payload.related_to_type = RelatedToType.Project;
    }

    this.activities$ = this.accountService.getActivities(payload).pipe(
      takeUntilDestroyed(this.destroyRef),
      tap(() => (this.loading = false)),
    );
  }
}
